import { ReactNode } from 'react';
import styled, { css } from 'styled-components';

type DropdownItemProps = { children?: ReactNode };

const DropdownItem = styled.li<DropdownItemProps>`
  text-transform: capitalize;
  border-bottom: ${({ theme }) => `1px solid ${theme.palette.borderColor}`};
  color: ${({ theme }) => theme.palette.neutral.darkest};
  cursor: pointer;
  font-size: 12px;
  font-weight: 300;
  padding: 8px 20px;
  white-space: nowrap;

  :last-child {
    border-bottom: none;
  }

  ${({ theme }) => {
    return css`
      :hover {
        background-color: ${theme.colors?.dropdownHover};
        text-decoration: ${theme.fonts.dropdownHover?.textDecoration};
        font-size: ${theme.fonts.dropdownHover?.fontSize};
        font-weight: ${theme.fonts.dropdownHover?.fontWeight};
        font-style: ${theme.fonts.dropdownHover?.fontStyle};
        color: ${theme.fonts.dropdownHover?.color};
        cursor: 'pointer';
      }
    `;
  }}
`;

export default DropdownItem;
